import React from 'react';

import boofinscout from '../imgs/boofinscout.jpg'; 
import cabinets from '../imgs/cabinets.jpg'; 
import caf from '../imgs/caf.jpg'; 
import camden from '../imgs/camden.jpg'; 
import david from '../imgs/david.jpg'; 
import doggies from '../imgs/doggies.jpg'; 
import earthelemental from '../imgs/earthelemental.png'; 
import edenface from '../imgs/edenface.png'; 
import edenghost from '../imgs/edenghost.jpg'; 
import eye1 from '../imgs/eye1.jpg'; 
import eye2 from '../imgs/eye2.jpg'; 
import eye3 from '../imgs/eye3.jpg'; 
import flower from '../imgs/flower.jpg'; 
import flowers from '../imgs/flowers.jpg'; 
import funnight1 from '../imgs/funnight1.jpg'; 
import funnight2 from '../imgs/funnight2.jpg'; 
import lunch from '../imgs/lunch.jpg'; 
import mjt from '../imgs/mjt.MOV'; 
import pano from '../imgs/pano.jpg'; 
import patio from '../imgs/patio.jpg'; 
import river from '../imgs/river.jpg'; 
import samdnd from '../imgs/samdnd.jpg'; 
import scotis from '../imgs/scotis.jpg'; 
import scout from '../imgs/scout.jpg'; 
import ustwo from '../imgs/ustwo.jpg'; 
import zumbopumbo from '../imgs/zumbopumbo.jpg'; 
import gloo from '../imgs/gloo.jpg'; 
import snowday from '../imgs/snowDay.jpg'; 
import colbieshake from '../imgs/colbieshake.PNG'; 

import gardenSpider from '../imgs/gardenSpider.png'; 
import newBike from '../imgs/newBike.png'; 

import skinnedCaverns from '../imgs/skinnedCaverns.png'; 
import endScene from '../imgs/endScene.png'; 
import endScene2 from '../imgs/endScene2.png'; 

import ppe from '../imgs/ppe.png'; 
import ppe2 from '../imgs/ppe2.png'; 

import rainypup from '../imgs/rainypup.png'; 
import festiveScout from '../imgs/festiveScout.png'; 





function Blog() {
    return (
        <body style={{backgroundColor: '#e7d3d380'}}>
            <div>
                <h2>Sweet spider I found</h2>
                <img src={gardenSpider} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>Vintage 1989 Le'Mans Centurian I bought</h2>
                <img src={newBike} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>1.5~ Year long campaign finale :)</h2>
                <img src={endScene} alt="caf" width="30%" height="30%"/>
                <img src={endScene2} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>The final chapter: Skinned Caverns</h2>
                <img src={skinnedCaverns} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>Apoceclipse ft. Unsafe scout</h2>
                <img src={ppe} alt="caf" width="30%" height="30%"/>
                <img src={ppe2} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>Workin Dog earnin their stay (not)</h2>
                <img src={rainypup} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>Festive puppy hate lightbulbs after this</h2>
                <img src={festiveScout} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>gloo, he's 12.</h2>
                <img src={gloo} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>Firm handshake but a few handsome gentleman I might say (screenshot)</h2>
                <img src={colbieshake} alt="caf" width="30%" height="30%"/>
            </div>
            <div>
                <h2>Crazy snow day in D town!</h2>
                <img src={snowday} alt="caf" width="30%" height="30%"/>
            </div>

            <div>
                <h2>These fell on Sam a while ago</h2>
                <img src={cabinets} alt="caf" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Whipped out the ol double dash, found my brothers initals CAF from prolly 15 years ago</h2>
                <img src={caf} alt="caf" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Family time :) </h2>
                <img src={funnight1} alt="funnight1" width="30%" height="30%"/>
                <img src={funnight2} alt="funnight2" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Pano of Pikes peak on top of rocky montain</h2>
                <img src={pano} alt="pano" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Some eyes for your collection</h2>
                <img src={eye1} alt="eye1" width="30%" height="30%"/>
                <img src={eye2} alt="eye2" width="30%" height="30%"/>
                <img src={eye3} alt="eye3" width="30%" height="30%"/>
            </div>

            <div >
                <h2>Some motivation for the boys back home</h2>
                <video width="30%" height="30%" controls>
                    <source src={mjt} type="video/quicktime"/>
                </video>
            </div>

            <div>
                <h2>Scout smoken purple listening to delicate steve</h2>
                <img src={boofinscout} alt="boofinscout" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Bro thinkin fr</h2>
                <img src={david} alt="david" width="30%" height="30%"/>
            </div>

            <div>
                <h2>It was our 1 year anniversary :) THE BUDS</h2>
                <img src={ustwo} alt="ustwo" width="30%" height="30%"/>
            </div>

            <div>
                <h2>lunch today was only 3.50 OKAY NICE</h2>
                <img src={lunch} alt="scotis" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Sampaign the other night, colbie got BANISHED</h2>
                <img src={samdnd} alt="scotis" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Somtimes in the morning this plant gets a flower</h2>
                <img src={flowers} alt="scotis" width="30%" height="30%"/>
            </div>


            <div>
                <h2>Eden, my wonderful wife, on the BIG SCREEN</h2>
                <img src={edenface} alt="scotis" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Eden, my wonderful wife, and I hung some new lights!</h2>
                <img src={patio} alt="scotis" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Scout and willow drinking some water after a nice romp around</h2>
                <img src={doggies} alt="scotis" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Saw Equilizer 3 with camden, guys were shot, I havent seen 1 or 2 before</h2>
                <img src={camden} alt="scotis" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Scout looks quite scary in this picture 😰</h2>
                <img src={scotis} alt="scotis" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Cool brain lookin flowers at lowes today</h2>
                <img src={flower} alt="flower" width="30%" height="30%"/>
            </div>

            <div>
                <h2>We had dnd the other night and the party killed an earth elemental and its rocky boys. Gj guys, thanks bella for the pic</h2>
                <img src={earthelemental} alt="earthelemental" width="30%" height="30%"/>
            </div>

            <div>
                <h2>Eden had some fun making a little spooky art the other day</h2>
                <img src={edenghost} alt="edenghost" width="30%" height="30%"/>
            </div>

            <div>
                <h2>This dog River (left) looks like my dog (right) thanks sam</h2>
                <img src={river} alt="someone elses dog" width="20%" height="20%"/>
                <img src={scout} alt="my dog" width="20%" height="20%"/>
            </div>

            <div >
                <h2>This is some foley I did, up to 38 secounds is all me baby</h2>
                <iframe title="foley" allow="autoplay;" allowfullscreen style={{border: 'none'}} src="https://clipchamp.com/watch/HpSs9mLFwVc/embed" width="640" height="360"></iframe>
            </div>

            <div>
                <h2>This is Zumbo Pumbo, I saved him from an underwater prison, glad you're alright Zumbo</h2>
                <img src={zumbopumbo} alt="zumbopumbo" width="30%" height="30%"/>
            </div>
        </body>

    );
}

export default Blog;
